// https://vuex.vuejs.org/en/getters.html

export default {
  getResellerName: state => resellerUid => {
    var reseller = state.list.find(c => {
      return c.uid === resellerUid;
    });
    return !reseller ? "Unknown reseller" : reseller.name;
  }
};
